import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class EventsBaseComponent extends BaseComponent {
  public text: string = "Events";

  constructor(userService: UserService) {
    super(userService);
  }
}
